import statusViewGenerator from './StatusViewGenerator.tsx';

import failedImage from './images/failed.png';

const FailedContent = statusViewGenerator(failedImage);

export default FailedContent;
